const mapping: Record<string, string> = {
  pipelineId: "eq",
  name: "like",
  pipelineName: "like",
  username: "like",
  status: "eq",
  schedulerId: "eq",
};

export const createFilterQuery = (
  filter: Array<{ id: string; value: any }>
) => {
  const query = filter
    .map(f => {
      const { id, value } = f;
      const type = mapping[id];
      if (!type) return "";
      return `${id}:${type}=${value}`;
    })
    .filter(Boolean);
  return query.join(",");
};
